module.exports = __webpack_public_path__ + "static/media/menu.4c86c1cb.svg";